import { configureStore } from '@reduxjs/toolkit';
import ticketsReducer from './ticketsSlice';
import entitiesReducer from './entitiesSlice';
import uiReducer from './uiSlice';
import notificationsReducer from './notificationsSlice';

const store = configureStore({
  reducer: {
    tickets: ticketsReducer,
    entities: entitiesReducer,
    ui: uiReducer,
    notifications: notificationsReducer,
  },
});

export default store;
